module.exports = __webpack_public_path__ + "img/workPermit1.92ab14b9.png";